import styled, { createGlobalStyle } from "styled-components";

export const MainBox = styled.div(({ theme, removePaddingOnMobile }) => ({
  padding: `${theme.spacers.pageY} ${theme.spacers.pageX}`,

  "@media(max-width: 1500px)": {
    padding: `${theme.spacers.pageY} clamp(20px,6vw,166px)`,
  },

  "@media(max-width: 1180px)": {
    margin: `auto`,
  },

  [`@media${theme.breakpoints.sm}`]: {
    padding: removePaddingOnMobile ? '0' : '22px',
  },
}));


export const TransactionContend = styled.div((props) => ({
 display: "flex", 
 flexWrap: 'wrap', 
 gap: '20px',
 marginTop: '40px',
 '& .transaction-row':{
  display: "flex", 
  flexDirection: "row", 
  justifyContent: "space-between",
  gap:"20px"
 },
 '& .transaction-button': {
  padding: '10px',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > img': {
    width: '15px',
    height: '15px',
    marginTop: '-10px',
  },
},

}));



const GlobalStyle = createGlobalStyle((props) => ({
 
  body: {
    padding: `0 0`,
    backgroundColor: props.theme.palette.gray["500"],
    fontFamily: props.theme.fontFamilies.jost,
  },
  "h1, h2, h3, h4, h5, h6": {
    fontWeight: 500,
    margin: 0,
  },

  h1: {
    fontWeight: 600,
    letterSpacing: "-1.728px",
    fontFamily: props.theme.fontFamilies.workSans,
    fontSize: props.theme.fontSizes.h1,
  },

  h2: {
    fontSize: props.theme.fontSizes.h2,
  },

  h3: {
    fontSize: props.theme.fontSizes.h3,
  },

  h4: {
    margin: `${props.theme.spacers["2"]} 0`,
    fontSize: props.theme.fontSizes.h4,
  },

  h5: {
    fontSize: props.theme.fontSizes.h5,
  },

  h6: {
    fontSize: props.theme.fontSizes.h6,
  },

  p: {
    fontSize: props.theme.fontSizes.p,
    margin: "5px",
  },

  div: {
    fontSize: props.theme.fontSizes.p,
  },

  a: {
    cursor: "pointer",
    color: props.theme.palette.blue.link,
  },

  ".error-caption": {
    fontSize: '0.75rem',
    color: props.theme.palette.primary.main,
    "@media(min-width: 2000px)": {
       fontSize:"1.5vh"
    },
  },

  ".dotted-border": {
    backgroundPosition: "bottom",
    backgroundRepeat: "repeat-x",
    backgroundSize: "10px 2px",
    backgroundImage:
      "linear-gradient(to right,#797676 10%,rgba(255,255,255,0) 0%)",
  },

  ".button-container": {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '2rem'
  },

  // '.MuiBox-root': {
  //     padding: '24px 0 !important',
  // },

  ".center-absolute": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  ".MuiFormControl-root": {
    "& input": {
      margin: 0,
      color: props.theme.palette.gray["900"],
      fontSize: props.theme.fontSizes.p,
      fontFamily: props.theme.fontFamilies.jost,
    },
  },

  'input[readonly], textarea[readonly]': {
    background: 'unset',
    outline: 'none',
    border: 'unset !important'
  },

  'input:-internal-autofill-selected': {
    backgroundColor: 'unset !important'
  },

  ".required::after": {
    content: "'*'",
    margin: "0 10px",
    color: props.theme.palette.primary.main,
  },

  "*": {
    "-webkit-tap-highlight-color": "transparent",  
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    body: {
      padding: 0,
    },
  },
}));

export default GlobalStyle;
